'use client';

export { default } from './OutlinedInput';
export { default as outlinedInputClasses } from './outlinedInputClasses';
export * from './outlinedInputClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/OutlinedInput/index.js
// module id = 333
// module chunks = 25